export default "__VITE_ASSET__Dx_Mer_8__"